import { get, getOr } from 'lodash/fp'
const localAsyncAction = function({
  key,
  initialState = null,
  fetcher: {
    methodName,
    handler,
    stateUpdater = ({ currentData }) => currentData
  }
}) {
  return {
    data: () => ({
      [key]: {
        error: null,
        loading: false,
        data: initialState
      }
    }),
    methods: {
      [methodName]: function(props) {
        this[key].loading = true
        return handler(props)
          .then(res => {
            let result = stateUpdater({
              prevState: this[key].data,
              currentData: res.data
            })
            this[key].data = result
            this[key].error = null
            this[key].loading = false
            return result
          })
          .catch(error => {
            this[key].error = getOr(
              error.message,
              'response.data.message',
              error
            )
            this[key].loading = false
            this.$toast.error(error, get('details', error))
            return Promise.reject(error)
          })
      }
    }
  }
}

export default localAsyncAction
